import { Link } from "react-router-dom";

interface MovieCardProps {
  id: string;
  title: string;
  image: string;
  rating: number;
  year: number;
  category: string;
  categoryName: string;
  tags?: string[];
  duration?: string;
}

export default function MovieCard({ id, title, image, rating, year, category, categoryName, tags, duration }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={`${title} - 红桃影视在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2">
          <span className="bg-accent-500 text-foreground-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="text-white/90 text-xs bg-white/20 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{year}</span>
          {duration && (
            <>
              <span className="text-foreground-300">·</span>
              <span>{duration}</span>
            </>
          )}
        </div>
        {tags && tags.length > 0 && (
          <div className="flex items-center gap-1 mt-2 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-[10px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">{tag}</span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}